<template>
    <hc-dialog
        fullscreen
        append-to-body
        title="新建演示数据"
        :visible.sync="visible"
        destroy-on-close
        custom-class="mock-dialog"
        :before-close="() => $emit('close')"
    >
        <!-- 步骤条 -->
        <div class="steps">
            <div
                v-for="item in stepOptions"
                :key="item.type"
                :class="[
                    {
                        active: currentStepType === item.type,
                        finished: currentStepType > item.type
                    },
                    'step'
                ]"
            >
                <span class="index">
                    <template v-if="currentStepType > item.type">
                        <i class="el-icon-check" />
                    </template>
                    <template v-else>
                        {{ item.type }}
                    </template>
                </span>
                <span class="title">{{ item.title }}</span>
            </div>
        </div>
        <!-- 步骤一 -->
        <div v-show="currentStepType === FIRST_STEP.type" class="upload-file">
            <hc-upload
                ref="mockUpload"
                drag
                :auto-upload="false"
                name="mockObjectFile"
                action="/api_v3/studio/mock/object/preview"
                accept=".xls, .xlsx"
                :class="['uploader']"
                :limit="1"
                :on-error="uploadError"
                :on-success="uploadScuess"
                :on-change="uploadChange"
                :on-remove="uploadRemove"
            >
                <svg-icon name="upload-file" />
                <div class="el-upload__text">
                    将文件拖拽到此处或<span>点击上传</span>
                    <div class="tip">
                        支持扩展名：.xls\xlsx，最多上传 1 个文件
                    </div>
                    <div v-if="hasFile" class="mask" @click.stop />
                </div>
            </hc-upload>
            <span class="downfile" @click="getTemplate">
                <svg-icon name="download" />下载演示数据模板.xls
            </span>
        </div>
        <!-- 步骤二 -->
        <template v-if="currentStepType === SECOND_STEP.type">
            <config-field ref="configField" :data="tableData" />
            <p class="config-tip">
                数据具体条数以上传的文件为准，此处仅展示10条作为示例。
            </p>
        </template>
        <!-- 步骤三 -->
        <template v-else-if="currentStepType === LAST_STEP.type">
            <div class="generate-success">
                <span class="icon">
                    <i class="el-icon-check" />
                </span>
                <h4>生成成功</h4>
                <p>成功生成 {{ mockDataCount }} 条数据</p>
            </div>
        </template>
        <div slot="footer">
            <template v-if="isFinished">
                <hc-button type="primary" @click="finishFn">
                    完成
                </hc-button>
            </template>
            <template v-else-if="isProceed">
                <hc-button plain @click="prevStep">
                    上一步
                </hc-button>
                <hc-button type="primary" :loading="loading" @click="toNextStep">
                    下一步
                </hc-button>
            </template>
            <template v-else>
                <hc-button plain @click="() => $emit('close')">
                    取消
                </hc-button>
                <hc-button
                    type="primary"
                    :disabled="!hasFile"
                    :loading="loading"
                    @click="toNextStep"
                >
                    下一步
                </hc-button>
            </template>
        </div>
    </hc-dialog>
</template>
<script>
import { mapActions } from 'vuex'

import { APP_RESOURCE } from '@common/store/module-types'
import * as T from '@common/store/app-resource/types'

import ConfigField from './config-fields'
import {
    STEP_OPTIONS, FIRST_STEP, SECOND_STEP, LAST_STEP,
} from './step-const'
import uploadMixin from './upload-mixin'

export default {
    name: 'MockDialog',
    components: {
        ConfigField,
    },
    mixins: [uploadMixin],
    props: {
        visible: Boolean,
    },
    data() {
        return {
            currentStepType: 1,
            stepOptions: STEP_OPTIONS,
            tableData: [],
            mockDataCount: 0,
            loading: false,
            FIRST_STEP,
            SECOND_STEP,
            LAST_STEP,
        }
    },
    computed: {
        isProceed() {
            const { currentStepType } = this
            return currentStepType < LAST_STEP.type && currentStepType > FIRST_STEP.type
        },
        isFinished() {
            return this.currentStepType >= LAST_STEP.type
        },
    },
    watch: {
        visible(v) {
            if (v) {
                this.initData()
            }
        },
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            uploadMockExcell: T.UPLOAD_MOCK_EXCELL,
            getMockTemplate: T.GET_MOCK_TEMPLATE,
            createMockObject: T.CREATE_MOCK_OBJECT,
        }),
        nextStep() {
            this.currentStepType++
        },
        toNextStep() {
            if (this.currentStepType === FIRST_STEP.type) {
                // 有上传通过的，上一步下一步不做处理，否则重新走上传校验的逻辑
                if (this.uploadSuccess) {
                    this.nextStep()
                } else {
                    this.loading = true
                    this.$refs.mockUpload.submit()
                }
            } else if (this.currentStepType === SECOND_STEP.type) {
                this.$refs.configField.validateObject()
                    .then(() => {
                        this.loading = true
                        const params = this.$refs.configField.getFields()
                        this.createMockObject(params)
                            .then(res => {
                                this.mockDataCount = res
                                this.nextStep()
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    })
            }
        },
        prevStep() {
            this.currentStepType--
        },
        finishFn() {
            this.$emit('success')
        },
        initData() {
            this.resetData()
        },
        resetData() {
            this.currentStepType = FIRST_STEP.type
            this.tableData = []
            this.mockDataCount = 0
            this.loading = false
            this.hasFile = false
            this.uploadSuccess = false
        },
        uploadError(err) {
            this.resetData()
            const { error } = JSON.parse(err?.message || '{"error":"上传失败"}')
            this.$message.error(error)
        },
        uploadScuess(res) {
            this.loading = false
            this.tableData = res
            this.uploadSuccess = true
            this.nextStep()
        },
        getTemplate() {
            const { origin } = location

            window.open(`${origin}/api_v3/studio/mock/object/data-template`)
        },
    },
}
</script>
<style lang="less" scoped>
.mock-dialog {
    .hc-dialog {
        /deep/ &__body {
            display: flex;
            padding: 0 32px;
            max-height: 100%;
            flex-direction: column;
            height: calc(100% - 56px - 72px);
        }
        /deep/ &__footer {
            display: flex;
            justify-content: center;
            .hc-button {
                min-width: 80px;
            }
            transition: all 0.3s ease;
        }
    }
    .steps {
        display: flex;
        padding: 0 80px;
        margin: 22px 0 24px 0;
        justify-content: space-between;
        .step {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            &:not(:first-child) {
                margin-left: 16px;
            }
            &:not(:last-child) {
                flex: 1;
                &:after {
                    content: '';
                    flex: 1;
                    height: 1px;
                    background: #EAEAEA;
                    margin-left: 8px;
                }
            }
            .index {
                width: 24px;
                height: 24px;
                color: #999;
                font-size: 14px;
                line-height: 22px;
                text-align: center;
                display: inline-block;
                border-radius: 50%;
                border: 1px solid #ddd;
                i {
                    font-size: 12px;
                    font-weight: 600;
                    color: #266EFF;
                }
            }
            .title {
                color: #999;
                margin-left: 8px;
                line-height: 22px;
            }
            &.active {
                .index {
                    color: #fff;
                    border: 1px solid #266EFF;
                    background-color: #266EFF;
                }
                .title {
                    color: #222;
                    font-weight: 600;
                }
            }
            &.finished {
                .index {
                    color: #fff;
                    border: 1px solid #266EFF;
                }
                .title {
                    color: #222;
                }
                &:after {
                    background: #266EFF;
                }
            }
        }
    }
    .config-tip {
        color: #ccc;
        font-size: 12px;
        margin-top: 16px;
        line-height: 20px;
    }
    .upload-file {
        width: 480px;
        align-self: center;
        .uploader {
            /deep/ .hc-upload {
                width: 100%;
            }
            /deep/ .hc-upload-dragger {
                width: 100%;
                height: auto;
                padding: 58px 0;
                position: relative;
                border-color: #ddd;
                .svg-icon {
                    color: #ccc;
                    font-size: 56px;
                }
                .el-upload__text {
                    color: #222;
                    margin-top: 4px;
                    span {
                        color:  #226EFF;
                        line-height: 20px;
                    }
                    .tip {
                        color: 12px;
                        color: #ccc;
                        line-height: 20px;
                        margin-top: 4px;
                    }
                }
                .mask {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    cursor: not-allowed;
                    background: rgba(238,238,238,0.6);
                }
            }
            .hc-upload.disabled {
                cursor: not-allowed;
            }
        }
        .downfile {
            align-items: center;
            display: inline-flex;
            cursor: pointer;
            font-size: 12px;
            margin-top: 32px;
            color: #266EFF;
            line-height: 20px;
            .svg-icon {
                font-size: 16px;
                margin-right: 4px;
            }
        }
    }
    .generate-success {
        display: flex;
        margin-top: 290px;
        align-items: center;
        flex-direction: column;
        .icon {
            width: 45px;
            height: 45px;
            display: flex;
            font-weight: 600;
            border-radius: 50%;
            align-items: center;
            background: #1CC78D;
            justify-content: center;
            i {
                color: #FFF;
                font-size: 33px;
            }
        }
        h4 {
            color: #333;
            font-size: 16px;
            margin-top: 24px;
            font-weight: 500;
            line-height: 24px;
        }
        p {
            color: #999;
            margin-top: 4px;
            font-size: 14px;
            line-height: 22px;
        }
    }
}
</style>
